import React, { useEffect } from "react";
import "./App.css";
import { Provider } from "jotai";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Confirm, Interceptor, AIConfirm, AI } from "@components";
import {
  Login,
  Home,
  HomeUpdate,
  ReelsCategory,
  ReelsCategoryUpsert,
  ReelsList,
  ReelsUpsert,
  ProductIntroduceList,
  ProductUpsert,
  DetailCategory,
  DetailCategoryUpsert,
  DetailInfoList,
  DetailInfoListUpsert,
  DetailContents,
} from "@pages";
import NavigationPage from "./NavigationPage";
import ReelsContent from "./pages/Reels/ReelsContent";
import CareerBackground from "./pages/CareerBackground/CareerBackground";
import CareerBackgroundUpdate from "./pages/CareerBackground/CareerBackgroundUpdate";
import { HOME_URL } from "@/config";
import PooNPeePrivacy from "./poonpee/pages/PooNPeePrivacy";
import PhoneFinderPrivacy from "./phonefinder/pages/PhoneFinderPrivacy";
import ScentPrivacy from "./scent/pages/ScentPrivacy";

const App = () => {
  // 전역 오류 캡처
  window.onerror = function (message, source, lineno, colno, error) {
    alert(JSON.stringify({ message, source, lineno, colno, error }));
    // 오류 발생으로 렌더링 깨짐 발생시 홈으로 이동
    window.location.href = `${HOME_URL}`;
  };
  // 카카오 SDK 초기화 (key는 3번에서 발급받은 JavaScript 키)
  if (window.Kakao) {
    window.Kakao.init("96e966c8de8a99c98a66fd1295427be3");
  }
  return (
    <div className="App">
      <div className="content-wrapper">
        <Provider>
          <AIConfirm />
          <Confirm />
          <Router>
            <Interceptor>
              <Routes>
                {/* TODO: 개발 편의를 위한 네비게이션 페이지. 개발 후 관련 로직 삭제 필요! */}
                <Route path="/navi" element={<NavigationPage />} />
                {/* 로그인 */}
                <Route path="/admin-login" element={<Login />} />
                {/* 홈 */}
                <Route path="/" element={<Home />} />
                <Route path="/home-update" element={<HomeUpdate />} />
                {/* 릴스 모아보기 */}
                <Route path="/reels-category" element={<ReelsCategory />} />
                <Route path="/reels-category-upsert/:tag">
                  <Route index element={<ReelsCategoryUpsert />} />
                  <Route path=":info" element={<ReelsCategoryUpsert />} />
                </Route>
                <Route path="/reels-list/:id/:title" element={<ReelsList />} />
                <Route path="/reels-upsert/:tag">
                  <Route index element={<ReelsUpsert />} />
                  <Route path=":info" element={<ReelsUpsert />} />
                </Route>
                <Route path="/reels-content/:info" element={<ReelsContent />} />
                {/* 상품 소개 */}
                <Route
                  path="/product-list"
                  element={<ProductIntroduceList />}
                />
                <Route path="/product-upsert/:tag">
                  <Route index element={<ProductUpsert />} />
                  <Route path=":info" element={<ProductUpsert />} />
                </Route>
                {/* 심화 정보 */}
                {/* 심화정보 오픈 메뉴에서 제외. 추후 다시 오픈 예정 */}
                {/* <Route path="/detail-category" element={<DetailCategory />} />
                <Route path="/detail-category-upsert/:tag">
                  <Route index element={<DetailCategoryUpsert />} />
                  <Route path=":info" element={<DetailCategoryUpsert />} />
                </Route>
                <Route
                  path="/detail-list/:id/:title"
                  element={<DetailInfoList />}
                />
                <Route
                  path="/detail-list-upsert/:tag/:info"
                  element={<DetailInfoListUpsert />}
                />
                <Route
                  path="/detail-contents/:info"
                  element={<DetailContents />}
                /> */}
                {/* 이력 */}
                <Route
                  path="/career-background"
                  element={<CareerBackground />}
                />
                <Route
                  path="/career-background-update/:images"
                  element={<CareerBackgroundUpdate />}
                />
                <Route path="/ai" element={<AI />} />
                <Route path="/poonpee/privacy" element={<PooNPeePrivacy />} />
                <Route
                  path="/phonefinder/privacy"
                  element={<PhoneFinderPrivacy />}
                />
                <Route path="/scent/privacy" element={<ScentPrivacy />} />
              </Routes>
            </Interceptor>
          </Router>
        </Provider>
      </div>
    </div>
  );
};

export default App;
